<template>
    <div>
        <slot name="top"></slot>
        <slot name="middle">
            <div style="padding: 20px">
                <Wp_limit_price_model ref="Wp_limit_price_model"
                                      @getPriceLimit="getPriceLimit"
                ></Wp_limit_price_model>

                <van-divider style="margin-top: 10px; margin-bottom: 10px; border-color: #dddddd"/>

                <Wp_limit_commission_share_model ref="Wp_limit_commission_share_model"
                                                 @getCommissionShareLimit="getCommissionShareLimit"

                ></Wp_limit_commission_share_model>
            </div>
        </slot>
        <slot name="bottom">
            <div style="position: absolute; top:400px; left: 0px; width: 100%">
                <van-row>
                    <van-col span="12" style="padding: 0px 5px 0px 20px">
                        <van-button type="info" size="small" style="width: 100%; height: 40px" @click="reset">重置</van-button>
                    </van-col>
                    <van-col span="12" style="padding: 0px 20px 0px 5px">
                        <van-button type="danger" size="small" style="width: 100%; height: 40px" @click="submit">确定</van-button>
                    </van-col>
                </van-row>
            </div>
        </slot>
    </div>
</template>

<script>
    import Wp_limit_price_model from "./Wp_limit_price_model";
    import Wp_limit_commission_share_model from "./Wp_limit_commission_share_model";
    export default {
        name: "Wp_options_filter_page",
        components: {Wp_limit_commission_share_model, Wp_limit_price_model},
        data(){
            return{
                price_min: '',
                price_max: '',

                commission_share_min: '',
                commission_share_max: '',
                // hasFilter: false,
            }
        },

        methods:{
            submit(){
                let price_limit = this.getLimitPrice();
                let commission_share_limit = this.getLimitCommissionShare();
                let filterData = {
                    price_min: price_limit.price_min,
                    price_max: price_limit.price_max,
                    commission_share_min: commission_share_limit.commission_share_min,
                    commission_share_max: commission_share_limit.commission_share_max,
                };

                this.$emit('getFilterData', filterData);

                if(filterData.price_min === -1 && filterData.price_max === -1
                    && filterData.commission_share_min === -1 && filterData.commission_share_max === -1){
                    this.$emit('hasFilter', false)
                }else{
                    this.$emit('hasFilter', true)
                }

            },

            reset(){
                this.$refs.Wp_limit_price_model.reset();
                this.$refs.Wp_limit_commission_share_model.reset();

                let filterData = {
                    price_min: -1,
                    price_max: -1,
                    commission_share_min: -1,
                    commission_share_max: -1,
                };
                this.$emit('getFilterData', filterData);
                this.$emit('hasFilter', false)
            },

            getLimitCommissionShare(){
                let commission_share_min_num = Number(this.commission_share_min) / this.$common.commissionRate_pir / 0.9;
                let commission_share_max_num = Number(this.commission_share_max) / this.$common.commissionRate_pir / 0.9;

                if(commission_share_min_num > 0 && commission_share_max_num === 0){
                    commission_share_max_num = -1;
                }
                if(commission_share_min_num === 0 && commission_share_max_num === 0){
                    commission_share_min_num = -1;
                    commission_share_max_num = -1;
                }

                return {
                    commission_share_min: commission_share_min_num,
                    commission_share_max: commission_share_max_num,
                };
            },

            getLimitPrice(){
                let price_min_num = Number(this.price_min);
                let price_max_num = Number(this.price_max);

                if(price_min_num > 0 && price_max_num === 0){
                    price_max_num = -1;
                }
                if(price_min_num === 0 && price_max_num === 0){
                    price_min_num = -1;
                    price_max_num = -1;
                }

                return {
                    price_min: price_min_num,
                    price_max: price_max_num,
                };
            },

            getPriceLimit(limit_price){
                this.price_min = limit_price.price_min_str;
                this.price_max = limit_price.price_max_str;
            },

            getCommissionShareLimit(limit_commission_share){
                this.commission_share_min = limit_commission_share.commission_share_min_str;
                this.commission_share_max = limit_commission_share.commission_share_max_str;
            }
        }
    }
</script>

<style scoped>

</style>